export class SignShapeType {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignShapeTypesChoices = {
  UPRIGHT: new SignShapeType('Opstaand', 0),
  LYING_DOWN: new SignShapeType('Liggend', 1),
  DIVERGENT: new SignShapeType('Afwijkend', 2)
};

export const SignShapeTypesChoiceArray = Object.values(SignShapeTypesChoices);
